import styled from "styled-components";

export const FormErrorMessage = styled.div`
  background: var(--errorMuted);
  color: var(--error);
  padding: 16px;
  border-radius: 5px;
`;
